const messages = {
    siteName: 'ButcherCrowd',
    errors: {
        internal: 'An internal error has occurred',
        passwordConfirmation: 'Passwords must match',
    },
} as const;

export default messages;
